import React from "react";
import { Container, Card } from "react-bootstrap";
import Banner from "../components/ContactUs/Banner";
import Features from "../components/ContactUs/Features";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "5rem",
      }}
    >
      <Banner
        header="Privacy Policy"
        text="Your Privacy, Our Priority: Unveiling the Shield on Your Information Security"
      />
      <Container className="my-5">
        <Card className="p-4 mb-4">
          <Card.Body>
            <Card.Title>Policy Brief & Purpose</Card.Title>
            <Card.Text>
              At Datacom, we prioritize the privacy and security of our
              customers' data. We are committed to ensuring that any data we
              collect from our customers, employees, and partners is kept safe
              and used only for legitimate business purposes.
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="p-4 mb-4">
          <Card.Body>
            <Card.Title>Scope</Card.Title>
            <Card.Text>
              Our privacy policy covers all individuals whose data we collect,
              including customers purchasing mobile phones, employees, and
              business partners. We aim to protect all personal and
              transactional data related to your mobile phone purchases and
              interactions with us.
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="p-4 mb-4">
          <Card.Body>
            <Card.Title>
              Who is Covered Under the Data Protection Policy?
            </Card.Title>
            <Card.Text>
              This policy applies to:
              <ul>
                <li>Mobile phone customers</li>
                <li>Employees</li>
                <li>Partners</li>
                <li>Consultants</li>
                <li>Third-party contractors</li>
              </ul>
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="p-4 mb-4">
          <Card.Body>
            <Card.Title>Policy Elements</Card.Title>
            <Card.Text>
              At Datacom, we collect the following data to provide you with an
              enhanced mobile phone shopping experience:
              <ul>
                <li>Name, email address, phone number</li>
                <li>Shipping and billing addresses</li>
                <li>Payment details for mobile phone purchases</li>
                <li>Order history and preferences</li>
              </ul>
              This data is stored securely and used only for fulfilling your
              order and providing customer support.
            </Card.Text>
            <Card.Text>
              <strong>Our data will be:</strong>
              <ul>
                <li>
                  Used to process your mobile phone orders and provide
                  after-sales support.
                </li>
                <li>
                  Protected from unauthorized access with state-of-the-art
                  security measures.
                </li>
              </ul>
            </Card.Text>
            <Card.Text>
              <strong>Our data will not be:</strong>
              <ul>
                <li>Shared with third-party vendors without your consent.</li>
                <li>Used for unsolicited marketing or communication.</li>
                <li>Sold or distributed to unauthorized parties.</li>
              </ul>
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="p-4 mb-4">
          <Card.Body>
            <Card.Title>Company Data Responsibility</Card.Title>
            <Card.Text>
              Datacom is responsible for ensuring that any data we collect is
              kept secure and is only used for legitimate purposes. You have the
              right to access, modify, or delete any personal information we
              hold about you.
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="p-4 mb-4">
          <Card.Body>
            <Card.Title>Actions</Card.Title>
            <Card.Text>
              To protect your data, Datacom implements a variety of security
              measures:
              <ul>
                <li>Data encryption for secure transactions.</li>
                <li>
                  Strict access control to ensure only authorized personnel have
                  access to sensitive information.
                </li>
                <li>
                  Regular security audits to protect against potential breaches.
                </li>
              </ul>
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="p-4 mb-4">
          <Card.Body>
            <Card.Title>Disciplinary Consequences</Card.Title>
            <Card.Text>
              Any employee or individual found violating our privacy policies
              will face disciplinary action, which may include termination of
              employment or legal action.
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="p-4 mb-4">
          <Card.Body>
            <Card.Title>Datacom</Card.Title>
            <Card.Text>
              Datacom operates under full legal rights and is committed to
              maintaining a secure and trustworthy environment for all our
              customers purchasing mobile phones. Unauthorized attempts to
              access or modify our website will result in termination of access
              and potential legal action.
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="p-4 mb-4">
          <Card.Body>
            <Card.Title>Copyrights</Card.Title>
            <Card.Text>
              All content related to mobile phones, including product
              descriptions, images, and pricing information, is protected by
              copyright. Unauthorized reproduction or distribution of this
              content is prohibited and may result in legal action.
            </Card.Text>
            <Card.Text>
              <em>
                "Our displayed information about mobile phones may occasionally
                be updated. For the most current details, feel free to contact
                our customer support team."
              </em>
            </Card.Text>
          </Card.Body>
        </Card>
      </Container>
      <Features />
    </div>
  );
};

export default PrivacyPolicy;
